import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Dialog } from '@headlessui/react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { Modal, InlineTextInput, BasicButton, SubmitButton } from '../../../components/Base';

import { refundOrder } from '../../../actions/order';

function RefundForm(props, ref) {
  const { register, errors, handleSubmit } = useForm();

  const [isVisible, setIsVisible] = useState(false);
  const [initialOrder, setInitialOrder] = useState(null);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);

  const dispatch = useDispatch();

  useImperativeHandle(ref, () => ({
    showForm,
    showFormWithInitialData,
  }));

  const showForm = () => setIsVisible(true);
  const closeForm = () => {
    setIsVisible(false);
    setInitialOrder(null);
    setIsSubmittingForm(false);
  };

  const showFormWithInitialData = (data) => {
    setInitialOrder(data);
    showForm();
  };

  const onSubmitForm = (data) => {
    setIsSubmittingForm(true);

    if (initialOrder) {
      dispatch(refundOrder(initialOrder.id, data))
        .then(() => closeForm())
        .catch(() => setIsSubmittingForm(false));
    }
  };

  return (
    <Modal
      isVisible={isVisible}
      ModalContent={
        <div className="sm:flex sm:items-start">
          <div className="w-full mt-3 text-center sm:mt-0 sm:text-left">
            <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
              {initialOrder &&
                (initialOrder.is_paid === 1 ? 'Refund Confirmation' : 'Void Confirmation')}
            </Dialog.Title>
            <div className="mt-5">
              <form id="refundForm" onSubmit={handleSubmit(onSubmitForm)}>
                <div>
                  Silahkan masukan 6-digit PIN untuk melakukan
                  {initialOrder && initialOrder.is_paid === 1 ? ' Refund ' : ' Void '}
                  pada Order
                  <strong> {`#${initialOrder?.order_no}`}</strong>
                </div>

                <InlineTextInput
                  type="number"
                  title="6-digit PIN"
                  inputRef={register({ required: true, minLength: 6, maxLength: 6 })}
                  name="refund_pin"
                  errorMessage={errors.refund_pin && 'Kolom 6-digit PIN harus diisi'}
                />
              </form>
            </div>
          </div>
        </div>
      }
      ModalButton={
        <>
          <SubmitButton
            type="submit"
            form="refundForm"
            text="Submit"
            textClass="text-white text-xs"
            isLoading={isSubmittingForm}
          />
          <BasicButton text="Cancel" textClass="text-white text-xs mr-2" onClick={closeForm} />
        </>
      }
    />
  );
}

export default forwardRef(RefundForm);
